import { lazy } from 'react';
const AsyncLockCircleIcon = /*#__PURE__*/lazy(() => import(
/* webpackChunkName: "@atlaskit-internal_mention/LockCircleIcon" */
'@atlaskit/icon/glyph/lock-circle').then(module => ({
  default: module.default
})));
export default AsyncLockCircleIcon;